import { useQuery } from "@tanstack/react-query";
import { VitrinService } from "@/services/vitrin-service";
import SearchClient from "@/features/search/components/search-client";
import SearchSkeleton from "@/features/search/components/search-skeleton";
import TopBar from "@/components/top-bar";

export default function SearchPage() {
  const { data, isPending } = useQuery({
    queryKey: ["search-categories"],
    queryFn: () => VitrinService.getCategories(),
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
  });
  const categories = data?.data ?? [];


  return (
    <div className="min-h-svh bg-secondary-background w-full pb-20 no-select">

      {
        isPending ?
          <>
            <TopBar />
            <SearchSkeleton />
          </>
          :
          <SearchClient categories={categories} />
      }
    </div>
  );
}
